import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetSupportCategoriesRequest } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'
import { GetSupportCategoriesResponse } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'

export const getSupportCategories = (request: GetSupportCategoriesRequest, options?: CashRequestOptions) =>
  post<GetSupportCategoriesRequest, GetSupportCategoriesResponse>('/2.0/cash/get-support-categories', request, {
    ...options,
    rejectOnError: true,
  })
